export const IDP_NAME_REGEX = /^[A-Za-z0-9.:/-]{3,32}$/;
export const DEFAULT_EMAIL_ATTRIBUTE_NAME = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress';

export enum DomainSuffix {
  PRD = '.cloud.tanium.com',
  STG = '.cloud.tan-stage.com',
  DEV = '.dev.cloud.tan-stage.com',
  PRD_GOV = '.cloud.taniumfed.com',
  STG_GOV = '.cloud.tanfed-stage.com',
  DEV_GOV = '.dev.cloud.tanfed-stage.com',
}

const baseDocs = 'https://help.tanium.com/bundle/ug_tanium_account/page/tanium_account';
export const DocLinks = {
  DOCS_HOME: `${baseDocs}/index.html`,
  GETTING_STARTED: `${baseDocs}/getting_started.html`,
  CONFIG_AD_FS: `${baseDocs}/configuring_AD_FS.html`,
  CONFIG_AZURE: `${baseDocs}/configuring_entra_id.html`,
  CONFIG_GOOGLE: `${baseDocs}/configuring_google.html`,
  CONFIG_OKTA: `${baseDocs}/configuring_okta.html`,
  CONFIG_ORACLE: `${baseDocs}/configuring_oracle_identity_cloud.html`,
  CONFIG_PING: `${baseDocs}/configuring_pingfederate.html`,
  CONFIG_SF: `${baseDocs}/configuring_salesforce.html`,
  VERIFY_DOMAIN: `${baseDocs}/add_domains.html`,
  IDP_ROLE_ASSIGN: `${baseDocs}/configuring_identity_providers_account.html`,
  TANIUM_RESOURCE_CENTER: 'https://help.tanium.com',
  TANIUM_TRUST_CENTER: 'https://help.tanium.com/bundle/ug_cloud_cloud/page/cloud/trust_compliance.html',
  TANIUM_SUPPORT_PORTAL: 'https://community.tanium.com/s/contactsupport',
  TANIUM_SUPPORT_PORTAL_USG: 'https://taniumgov.my.site.com/s/login/',
  TANIUM_TITANS_COMMUNITY: 'https://community.tanium.com/s/community-discussions-and-groups',
  TANIUM_PARTNERS: 'https://partners.tanium.com',
  TANIUM_DEVELOPER: 'https://developer.tanium.com',
  TANIUM_TRAINING: 'https://www.tanium.com/learning/training',
  TANIUM_LEGAL: 'https://www.tanium.com/legal',
};

export const DataRegions = {
  US_E1: 'us-e1',
  US_C1: 'us-c1',
  EU_N1: 'eu-n1',
  JP_E1: 'jp-e1',
  CA_C1: 'ca-c1',
  UK_S1: 'uk-s1',
  AU_E1: 'au-e1',
  SA_E1: 'sa-e1',
  SG_SE1: 'sg-se1',
};

export const getRegionDisplayName = (region: string | undefined): string => {
  switch (region) {
    case DataRegions.US_E1:
      return 'United States';
    case DataRegions.US_C1:
      return 'United States';
    case DataRegions.EU_N1:
      return 'European Union';
    case DataRegions.JP_E1:
      return 'Japan';
    case DataRegions.CA_C1:
      return 'Canada';
    case DataRegions.UK_S1:
      return 'United Kingdom';
    case DataRegions.AU_E1:
      return 'Australia';
    case DataRegions.SA_E1:
      return 'South America';
    case DataRegions.SG_SE1:
      return 'Singapore';
  }
  return 'Unknown';
};
